import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import { MyHrLoginTwoFactorVerifyTotpCode } from "my-hr/components";

type MyHrLoginTwoFactorLoginTotpProps = {
  onForward: () => void;
  onCancel: () => void;
};

export const MyHrLoginTwoFactorLoginTotp = ({
  onForward,
  onCancel,
}: MyHrLoginTwoFactorLoginTotpProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "304px",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      <Box
        sx={{ textAlign: "center", marginTop: "24px", marginBottom: "16px" }}
      >
        <Typography variant="body1">{t("MY_HR_2FA_APP_LOGIN_INFO")}</Typography>
      </Box>
      <MyHrLoginTwoFactorVerifyTotpCode
        onForward={onForward}
        onCancel={onCancel}
        isRegister={false}
      />
    </Box>
  );
};

export default MyHrLoginTwoFactorLoginTotp;
